import { httpClient } from "../http-client/base-client";
import { ApiPostStatus, ApiStatus } from "../types/status/api-types";

export const StatusResource = {
  async getStatus(): Promise<ApiStatus> {
    const status = await httpClient.get<ApiStatus>("status");
    return status;
  },

  async postStatus(status: ApiPostStatus): Promise<void> {
    await httpClient.post<void>("admin/status", status);
  },
};
